import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { IonicModule } from '@ionic/angular';

import { FilterResumeResultsByDatePageRoutingModule } from './filter-resume-results-by-date-routing.module';

import { FilterResumeResultsByDatePage } from './filter-resume-results-by-date.page';
import { MatFormField, MatFormFieldModule, MatInputModule, MatNativeDateModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FilterResumeResultsByDatePageRoutingModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
  ],
  declarations: [FilterResumeResultsByDatePage]
})
export class FilterResumeResultsByDatePageModule {}
